import React, { useState, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';

const EmailPreviewModal = ({
  openModal = false,
  onClosed,
}) => {
  const [modal, setModal] = useState(openModal);

  useEffect(() => {
    setModal(openModal);
  }, [openModal]);

  const toggleModal = () => setModal(!modal);

  const onModalClosed = () => {
    setModal(false);
    onClosed();
  }

  return (
    <Modal isOpen={modal} toggle={toggleModal} size="md" onClosed={onModalClosed}>
      <ModalBody>
        <div className="account-setup-modal">
          <div className="email-content">
            <span className="d-flex justify-content-center mb-3"><img src="/logo-full.png" alt="" /></span>
            <h5>{`Hi < Friend's First Name >,`}</h5>
            <p>{`< User's First Name > gave you up to $75 towards your first month.`}</p>
            <p>On MYRA, you can take control of all your personal finances.
              Join to get $50 off your first month of financial planning and $25 off your tax filing.
                   Coupons expire one year from date of sign up.</p>
          </div>
          <div className="accept-btn">
            <button className="custom-btn-primary"> ACCEPT INVITATION</button>
          </div>
          <span className="d-flex flex-column mt-2">
            <p className="mb-0">Best Regards,</p>
            <p>MYRA Support Team</p>
          </span>
        </div>
      </ModalBody>
    </Modal>
  )
};

export default EmailPreviewModal;
